export type Range = { from: string; to: string };  // "YYYY-MM"

export function currentMonth(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function defaultRange(): Range {
  const to = currentMonth();
  const [y, m] = to.split("-").map(Number);
  let fm = m - 5, fy = y;
  while (fm < 1) { fm += 12; fy -= 1; }
  return { from: `${fy}-${String(fm).padStart(2, "0")}`, to };
}

export function presetRange(preset: "corrente" | "3" | "6" | "12" | "ytd"): Range {
  const to = currentMonth();
  const [y, m] = to.split("-").map(Number);
  if (preset === "corrente") return { from: to, to };   // grafici a granularità giornaliera
  if (preset === "ytd") return { from: `${y}-01`, to };
  const n = Number(preset);
  let fm = m - n + 1, fy = y;
  while (fm < 1) { fm += 12; fy -= 1; }
  return { from: `${fy}-${String(fm).padStart(2, "0")}`, to };
}

export function monthsInRange(from: string, to: string): string[] {
  const [yf, mf] = from.split("-").map(Number);
  const [yt, mt] = to.split("-").map(Number);
  const out: string[] = [];
  let y = yf, mo = mf;
  while (y < yt || (y === yt && mo <= mt)) {
    out.push(`${y}-${String(mo).padStart(2, "0")}`);
    mo++; if (mo > 12) { mo = 1; y++; }
  }
  return out;
}
